import { ApplicationMessageSource } from './models/application-message-source';
import { Injectable } from '@angular/core';
import { ApplicationErrorHandler } from './models/application-error-handler';
import { ApplicationErrorInfo } from './models/application-error-info';
import { CustomMessageService } from './message.service';
import { UrlProviderService } from './url-provider.service';
import { ApplicationMessage } from './models/application-message';
import { MessageType } from './models/enum/message-type';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DefaultApplicationErrorHandlerService
  implements ApplicationErrorHandler
{
  public handle(errorInfo: ApplicationErrorInfo) {
    let userMessage = new ApplicationMessage();
    userMessage.type = MessageType.Error;

    let ts = this.translateService;

    userMessage.summary = ts.instant('error');
    userMessage.sourceId = ApplicationMessageSource.global;

    if (errorInfo.messages && errorInfo.messages.length > 0) {
      userMessage.detail = errorInfo.messages[0];
    }

    this.messageService.pushMessage(userMessage);
  }

  constructor(
    private messageService: CustomMessageService,
    private translateService: TranslateService
  ) {}
}
